<template>
    <div :class="{'is-edited': editable}" class="report-container">
        <div class="report-head">
            <div @click="switchEdit" class="name" v-if="!editable"><span
                    class="name">{{report.name}}</span>
            </div>
            <input :placeholder="$t('automatic.namePlaceholder')" type="text" v-else
                   v-model="report.name">
            <font-awesome-icon @click="switchEdit" icon="chevron-down" v-if="!editable"/>
            <font-awesome-icon @click="switchEdit" icon="chevron-up" v-else/>

        </div>
        <div class="report-body" v-if="editable">
            <div class="report-element">
                <button @click="removeReport">{{$t('general.remove')}}</button>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.language')}}:</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :options="languages"
                        :placeholder="$t('multiselect.placeholder')"
                        :searchable="false"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        :show-labels="false"
                        v-model="locale">
                    >
                </multiselect>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.type')}}:</div>
                <multiselect
                        :allowEmpty="false"
                        :options="reportsType"
                        :placeholder="$t('automatic.selectType')"
                        :searchable="false"
                        :show-labels="false"
                        label="label"
                        track-by="id"
                        v-model="selectedType"
                ></multiselect>
            </div>
            <div class="report-element" v-if=
                    "selectedType.id === 'HOURLY'
            || selectedType.id === 'HOURLY_WEATHER'">
                <div class="label">{{$t('automatic.serialNumber')}}</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :multiple="false"
                        :show-labels="false"
                        :options="availableDevices"
                        :placeholder="$t('multiselect.placeholder')"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        label="name"
                        track-by="serialNumber"
                        v-model="serialNumber"
                ></multiselect>
            </div>
            <div class="report-element" v-else>
                <div class="label">{{$t('automatic.groups')}}:</div>
                <multiselect
                        :allowEmpty="false"
                        :clear-on-select="false"
                        :close-on-select="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :multiple="true"
                        :options="groups"
                        :placeholder="$t('multiselect.placeholder')"
                        :preserve-search="true"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        label="name"
                        track-by="id"
                        v-model="selectedGroups"
                />
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.status.active')}}:</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :options="isActive"
                        :placeholder="$t('multiselect.placeholder')"
                        :searchable="false"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        :show-labels="false"
                        label="label"
                        track-by="id"
                        v-model="activity"
                ></multiselect>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.fileType')}}</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :options="fileTypes"
                        :placeholder="$t('multiselect.placeholder')"
                        :searchable="false"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        :show-labels="false"
                        v-model="fileType"></multiselect>
            </div>
            <div class="report-element" v-if="fileType === 'CSV'">
                <div class="label">{{$t('automatic.fileEncoding')}}</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :options="fileEncodings"
                        :placeholder="$t('multiselect.placeholder')"
                        :searchable="false"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        :show-labels="false"
                        v-model="fileEncoding"></multiselect>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.sendNow')}}:</div>
                <multiselect
                        :allowEmpty="false"
                        :deselectLabel="$t('multiselect.deselectLabel')"
                        :options="sendNow"
                        :placeholder="$t('multiselect.placeholder')"
                        :searchable="false"
                        :selectLabel="$t('multiselect.selectLabel')"
                        :selectedLabel="$t('multiselect.selectedLabel')"
                        :show-labels="false"
                        label="label"
                        track-by="id"
                        v-model="sendingNow"
                ></multiselect>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.days')}}:</div>
                <input :placeholder="$t('automatic.days')" name="daysNumber" type="text" v-model="daysNumber"
                       v-validate="'required|min_value:1'">
                <span>{{ errors.first('daysNumber') }}</span>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.start')}}:</div>
                <div class="date-container">
                    <md-datepicker md-immediately
                                   v-model="startDate"
                    ></md-datepicker>
                    <VueTimepicker format="HH:mm:ss" v-model="startHour"></VueTimepicker>
                </div>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.monthInterval')}}:</div>
                <input :placeholder="$t('automatic.monthInterval')" min="0" name="monthInterval" v-model="monthInterval"
                       v-validate="'required|min_value:0'">
                <span>{{ errors.first('monthInterval') }}</span>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.dayInterval')}}:</div>
                <input :placeholder="$t('automatic.dayInterval')" min="0" name="dayInterval" v-model="dayInterval"
                       v-validate="'required|min_value:0'">
                <span>{{ errors.first('dayInterval') }}</span>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.hourInterval')}}:</div>
                <input :placeholder="$t('automatic.hourInterval')" min="0" name="hourInterval" v-model="hourInterval"
                       v-validate="'required|min_value:0'">
                <span>{{ errors.first('hourInterval') }}</span>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.minuteInterval')}}:</div>
                <input :placeholder="$t('automatic.minuteInterval')" min="0" name="minuteInterval"
                       v-model="minuteInterval" v-validate="'required|min_value:0'">
                <span>{{ errors.first('minuteInterval') }}</span>
            </div>
            <div class="report-element" v-if="role === 'OPTIGUARD'">
                <div class="label">{{$t('automatic.cronExpression')}}:</div>
                <input placeholder="* * * * * *" type="text" v-model="cron">
                <div><a
                        href="http://www.quartz-scheduler.org/documentation/quartz-2.3.0/tutorials/crontrigger.html"
                        target="_blank">instrukcja</a>
                </div>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.next')}}:</div>
                <!--        <md-datepicker :md-disabled-dates="gateKeeper" md-immediately
                                       v-model="report.nextDate"></md-datepicker>-->
                <div class="next-delivery">{{nextCDate}}</div>
            </div>
            <div class="report-element">
                <div class="label">{{$t('automatic.delivery')}}:</div>
                <div class="add-link">
                    <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                    <button
                            @click.prevent="addDelivery"
                            href="/">
                        {{$t('automatic.addDelivery')}}
                    </button>
                </div>
                <div class="message" v-if="deliveriesCount">
                    {{$t('automatic.deliveryRequired')}}
                </div>
                <div class="deliveries">
                    <Delivery :delivery="delivery" :key="delivery.index" @removeDelivery="removeDelivery"
                              v-for="(delivery, index) in deliveries"></Delivery>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-material/dist/vue-material.min.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Delivery from '@/components/reportManager/Delivery';

export default {
  name: 'Report',
  components: {
    Delivery,
    Multiselect,
    VueTimepicker,
  },
  props: {
    report: {
      type: Object,
      required: false,
    },
    devices: {
      type: Array,
      required: false,
    },
  },
  watch: {
    daysNumber(newValue) {
      this.report.daysNumber = newValue;
    },
    fileType(newValue) {
      this.report.fileType = newValue;
    },
    fileEncoding(newValue) {
      this.report.fileEncoding = newValue;
    },
    monthInterval(newValue) {
      this.report.monthInterval = parseInt(newValue, 10);
    },
    dayInterval(newValue) {
      this.report.dayInterval = parseInt(newValue, 10);
    },
    minuteInterval(newValue) {
      this.report.minuteInterval = parseInt(newValue, 10);
    },
    hourInterval(newValue) {
      this.report.hourInterval = parseInt(newValue, 10);
    },
    startHour(newValue) {
      this.report.startHour = newValue;
      this.report.startDate = `${this.startDate} ${newValue}`;
    },
    startDate(newValue) {
      this.report.startDate = `${newValue} ${this.startHour}`;
    },
    selectedType(newValue) {
      if (this.loaded) {
        this.report.reportType = newValue.id;
        if (newValue.id === 'HOURLY_WEATHER' || newValue.id === 'HOURLY') {
          this.selectedGroups = [];
          if (this.report.serialNumber) {
            this.serialNumber = this.devices.find(t => t.serialNumber === this.report.serialNumber);
          } else {
            this.serialNumber = this.devices[0];
          }
        } else if (this.selectedGroups.length > 0) {

        } else {
          this.selectedGroups.push(this.groups[0]);
        }
      }
    },
    locale(newValue) {
      this.report.locale = newValue;
    },
    cron(newValue) {
      this.report.cron = newValue;
    },
    activity(newValue) {
      this.report.enabled = newValue.id;
    },
    sendingNow(newValue) {
      this.report.sendNow = newValue.id;
    },
    selectedGroups(newValue) {
      this.report.selectedGroups = newValue;
    },
    deliveries(newValue) {
      this.report.delivery = newValue;
      if (newValue.length > 1) {
        this.deliveriesCount = false;
      }
    },
    serialNumber(newValue) {
      if (this.loaded && newValue) {
        this.report.serialNumber = newValue.serialNumber;
      }
    },
  },
  data() {
    return {
      languages: [],
      locale: '',
      daysNumber: 1,
      fileType: '',
      fileEncoding: '',
      fileTypes: [
        'EXCEL',
        'CSV',
      ],
      fileEncodings: [
        'CP1250',
        'UTF8',
      ],
      deliveryIndex: 0,
      editable: false,
      reportsType: [
        { id: 'HOURLY', label: this.$t('automatic.types.hourly') },
        { id: 'HOURLY_WEATHER', label: this.$t('automatic.types.hourlyWeather') },
        { id: 'DAILY_HOURS', label: this.$t('automatic.types.dailyHours') },
        { id: 'DAILY_HOURS_WEATHER', label: this.$t('automatic.types.dailyHoursWeather') },
        { id: 'WEEKLY_DAYS', label: this.$t('automatic.types.weeklyDays') },
        { id: 'WEEKLY_DAYS_WEATHER', label: this.$t('automatic.types.weeklyDaysWeather') },
      ],
      timeInterval: [
        { id: 'DAY', label: this.$t('automatic.intervals.day') },
        { id: 'HOUR', label: this.$t('automatic.intervals.hour') },
        { id: 'MINUTE', label: this.$t('automatic.intervals.minute') },
      ],
      isActive: [
        { id: true, label: this.$t('general.yes') },
        { id: false, label: this.$t('general.no') },
      ],
      sendNow: [
        { id: true, label: this.$t('general.yes') },
        { id: false, label: this.$t('general.no') },
      ],
      addDateToFileName: [
        { id: true, label: this.$t('general.yes') },
        { id: false, label: this.$t('general.no') },
      ],
      nextReport: '',
      reportParameters: '',
      delivery: [],
      deliveryPlaces: ['mail',
        'FTP'],
      selectedGroups: [],
      selectedType: {},
      selectedInterval: '',
      active: '',
      monthInterval: 0,
      dayInterval: 0,
      hourInterval: 0,
      minuteInterval: 0,
      now: 0,
      originalDate: '',
      nextDate: '',
      cron: '',
      loaded: false,
      activity: {},
      sendingNow: {},
      startDate: '2001-09-11',
      startHour: '21:37:00',
      deliveries: [],
      availableDevices: [],
      serialNumber: {},
      role: this.$store.getters.role,
      deliveriesCount: false,

      disabledDates: (date) => {
        const today = Date.now();

        return date < today;
      },
      gateKeeper: (date) => {
        const blockedDate = new Date(this.report.startDate);

        return date < blockedDate;
      },
    };
  },
  computed: {
    groups() {
      return this.$store.getters.groups;
    },
    nextCDate() {
      const startDate = new Date(`${this.startDate}T${this.startHour}`);
      if (parseInt(this.monthInterval, 10) > 0 || parseInt(this.dayInterval, 10) > 0 || parseInt(this.hourInterval, 10) > 0 || parseInt(this.minuteInterval) > 0) {
        if (this.now > startDate) {
          let iteration = startDate;
          while (iteration < this.now) {
            const date = iteration;
            if (parseInt(this.monthInterval, 10) > 0) {
              date.setMonth(date.getMonth() + parseInt(this.monthInterval, 10));
            }
            if (parseInt(this.dayInterval, 10) > 0) {
              date.setDate(date.getDate() + parseInt(this.dayInterval));
            }
            if (parseInt(this.hourInterval, 10) > 0) {
              date.setHours(date.getHours() + parseInt(this.hourInterval));
            }
            if (parseInt(this.minuteInterval, 10) > 0) {
              date.setMinutes(date.getMinutes() + parseInt(this.minuteInterval));
            }
            iteration = date;
          }
          return this.formatDate(iteration);
        }
        if (parseInt(this.monthInterval, 10) > 0) {
          startDate.setMonth(startDate.getMonth() + parseInt(this.monthInterval));
        }
        if (parseInt(this.dayInterval, 10) > 0) {
          startDate.setDate(startDate.getDate() + parseInt(this.dayInterval));
        }
        if (parseInt(this.hourInterval, 10) > 0) {
          startDate.setHours(startDate.getHours() + parseInt(this.hourInterval));
        }
        if (parseInt(this.minuteInterval, 10) > 0) {
          startDate.setMinutes(startDate.getMinutes() + parseInt(this.minuteInterval));
        }
        return this.formatDate(startDate);
      }
      return `${this.startDate} ${this.startHour}`;
    },
  },
  methods: {
    addDelivery() {
      this.deliveries.unshift({
        selectedType: 'e-mail',
        email: this.$store.getters.user.username,
        index: this.deliveryIndex,
      });
      this.deliveryIndex += 1;
    },
    switchEdit() {
      this.editable = !this.editable;
      if (this.report.id > 0) {
        this.$emit('editSwitch', this.$vnode.key);
      }
    },
    removeDelivery(key) {
      if (this.deliveries.length > 1) {
        const index = this.deliveries.indexOf(this.deliveries.find(delivery => delivery.index === key));
        this.deliveries.splice(index, 1);
      } else {
        this.deliveriesCount = true;
      }
    },
    removeReport() {
      this.$emit('removeReport', this.$vnode.key);
    },
    formatDate(date) {
      const d = new Date(date);
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = d.getFullYear();
      let hours = d.getHours();
      let minutes = d.getMinutes();
      let seconds = d.getSeconds();

      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  mounted() {
    const langs = this.$i18n.messages;
    this.languages = Object.keys(langs);
    this.originalDate = this.report.startDate;
    this.$material.locale = {
      startYear: 1900,
      endYear: 2099,
      dateFormat: 'yyyy-MM-dd',
      firstDayOfAWeek: 0,
      days: this.$t('datepicker.days'),
      shortDays: this.$t('datepicker.shortDays'),
      shorterDays: this.$t('datepicker.shorterDays'),
      months: this.$t('datepicker.months'),
      shortMonths: this.$t('datepicker.shortMonths'),
      shorterMonths: this.$t('datepicker.shorterMonths'),
    };
    this.now = new Date();
    if (this.report.enabled !== undefined) {
      this.activity = this.isActive.find(t => t.id === this.report.enabled);
    } else {
      this.activity = this.isActive.find(t => t.id === true);
    }
    if (this.report.sendNow !== undefined) {
      this.sendingNow = this.sendNow.find(t => t.id === this.report.sendNow);
    } else {
      this.sendingNow = this.sendNow.find(t => t.id === false);
    }
    if (this.report.reportType !== undefined) {
      this.selectedType = this.reportsType.find(t => t.id === this.report.reportType);
    } else {
      this.selectedType = this.reportsType.find(t => t.id === 'HOURLY');
    }
    if (this.report.monthInterval === undefined) {
      this.monthInterval = 0;
    } else {
      this.monthInterval = parseInt(this.report.monthInterval);
    }
    if (this.report.dayInterval === undefined) {
      this.dayInterval = 0;
    } else {
      this.dayInterval = this.report.dayInterval;
    }
    if (this.report.hourInterval === undefined) {
      this.hourInterval = 0;
    } else {
      this.hourInterval = this.report.hourInterval;
    }
    if (this.report.minuteInterval === undefined) {
      this.minuteInterval = 0;
    } else {
      this.minuteInterval = this.report.minuteInterval;
    }
    if (this.report.daysNumber === undefined) {
      this.daysNumber = 1;
    } else {
      this.daysNumber = this.report.daysNumber;
    }
    if (this.report.cron === undefined) {
      this.cron = '';
    } else {
      this.cron = this.report.cron;
    }
    if (this.report.serialNumber) {
      this.serialNumber = this.devices.find(t => t.serialNumber === this.report.serialNumber);
    }
    if (this.report.fileType !== undefined) {
      this.fileType = this.report.fileType;
    } else {
      this.fileType = this.fileTypes[0];
    }

    if (this.report.fileEncoding !== undefined) {
      this.fileEncoding = this.report.fileEncoding;
    } else {
      this.fileEncoding = this.fileEncodings[0];
    }
    if (this.groups !== undefined) {
      if (this.report.groups === undefined) {
        this.report.groups = [];
      } else if (this.report.groups.length > 0) {
        const groups = [];
        this.report.groups.forEach((group) => {
          groups.push(this.groups.find(t => t.id === group));
        });
        this.selectedGroups = groups;
      } else {
        this.selectedGroups.push(this.groups[0]);
      }
    }
    if (!this.report.locale) {
      this.locale = this.$i18n.locale;
    } else {
      this.locale = this.report.locale;
    }
    if (this.report.startDate !== undefined) {
      const startDate = this.report.startDate.split(' ');
      this.startDate = startDate[0];
      this.startHour = startDate[1];
    }
    const ftpDeliveries = [];
    const mailDeliveries = [];
    if (this.report.ftpReportDestinations !== undefined) {
      this.report.ftpReportDestinations.forEach((ftp) => {
        ftp.selectedType = 'FTP';
        ftpDeliveries.push(ftp);
      });
    }
    if (this.report.mailReportDestinations !== undefined) {
      this.report.mailReportDestinations.forEach((mail) => {
        mail.selectedType = 'e-mail';
        mailDeliveries.push(mail);
      });
    }
    let i = 0;
    const deliveries = ftpDeliveries.concat(mailDeliveries);
    deliveries.forEach((delivery) => {
      delivery.index = i;
      i += 1;
    });
    this.deliveryIndex = i;

    this.deliveries = deliveries;
    if (this.deliveries.length <= 0) {
      this.deliveries.push({
        selectedType: 'e-mail',
        email: this.$store.getters.user.username,
        index: this.deliveryIndex,
      });
      this.deliveryIndex -= 1;
    }

    this.availableDevices = this.devices;
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
    .next-delivery {
        color: $peacock-blue;
        font-weight: bold;
        font-size: 21px;
    }

    .report-container {
        background: white;
        box-shadow: 0 5px 6px $baseShadow;
        border-radius: 5px;
        margin: 25px auto;
        width: 48%;
        box-sizing: border-box;
        transition: all 150ms ease-in;
        max-height: 60px;
        padding: 15px 0;

        &.is-edited {
            max-height: 2000px;
            padding: 15px 30px;
            overflow-y: auto;
        }

        .report-head {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            align-items: center;
            transition: all 300ms ease-in;

            .name {
                font-weight: bold;
                cursor: pointer;
            }
        }

        input {
            color: #878a94;
            font-size: rem(14px);
            line-height: 19px;
            padding: 20px;
            box-sizing: border-box;
            width: 95%;
            height: 100%;
            border: 1px solid $border-blue;
        }

        .report-element {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            margin: 15px auto;

            .label {
                text-align: left;
                font-weight: bold;
            }
        }

    }

    .add-link {
        font-size: rem(18px);
        color: #005fab;
        font-weight: 900;
        line-height: 40px;
        display: flex;
        /*justify-content: space-between;*/
        align-items: center;
        margin-right: 36px;
        margin: 15px 0;
        text-align: left;

        a {
            margin-left: 17px;
            text-decoration: none;

            &:active, &:hover, &:visited {
                color: #005fab;
            }
        }

    }

    .add-link {
        font-size: rem(18px);
        color: #005fab;
        font-weight: 900;
        line-height: 40px;
        display: flex;
        /*justify-content: space-between;*/
        align-items: center;
        margin-right: 36px;
        text-align: left;

        button {
            margin-left: 17px;
            text-decoration: none;
            border: none;
            color: #005fab;
            background: none;
            font-weight: bold;

            &:active, &:hover, &:visited {
                color: #005fab;
            }
        }

    }

    button {
        margin-left: 17px;
        text-decoration: none;
        border: none;
        color: #005fab;
        background: none;
        font-weight: bold;

        &:active, &:hover, &:visited {
            color: #005fab;
        }
    }

    .vue__time-picker.time-picker {
        input.display-time {
            border: none !important;
            font-size: 16px !important;
            color: $peacock-blue !important;

        }
    }

    .date-container {
        display: flex;
    }
</style>
